import React from 'react';
import Accounts from '../../../modules/Accounts/components/Accounts';

const AccountsManager = () => {
  return (
    <Accounts />
  );
};

export default AccountsManager;